<template>
  <b-row>
    <b-col sm="2" lg="2">
      <b-form-checkbox v-model="video.video_use"> 사용여부 </b-form-checkbox>
    </b-col>
    <b-col>
      <b-form-group>
        <b-form-input
          placeholder="동영상주소(http://~)"
          v-model="video.link"
        ></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-input
        placeholder="from(00:00:00)"
        v-model="video.video_from"
      ></b-form-input>
    </b-col>
    <b-col cols="2">
      <b-form-input
        placeholder="to(00:00:00)"
        v-model="video.video_to"
      ></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-button @click="remove" variant="danger" size="sm">D</b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["video"],
  methods: {
    remove() {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeVideo", this.video);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
</style>